// src/reducers/index.js
// Import combineReducers utility from redux to combine multiple reducers
import { combineReducers } from 'redux';

// Import the authReducer to handle authentication-related state changes
import { authReducer } from '../auth/authReducer'; // Ensure the path is correct based on your project structure

// Use combineReducers to combine different reducers into a single rootReducer
// Each key in the object passed to combineReducers corresponds to a slice of the application state
// and is managed by the reducer assigned to that key
const rootReducer = combineReducers({
    auth: authReducer, // Assign authReducer to manage the 'auth' slice of the state
});

// Export the combined rootReducer
// This rootReducer will be used when creating the Redux store and determines how the state updates
export default rootReducer;
